import { FC } from "react";
import CustomPopup from "../../../../components/CustomPopup/CustomPopup";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Colors } from "../../../../styles/constant";
import "./LeadIntentPopup.scss";
import { Button, Stack, Typography } from "@mui/material";
import { tabViewPoint } from "../../../../utils/constants";
import useWindowSize from "../../../../hooks/useWindowSize";
import greatChoiceImg from "../../../../assets/images/great-choice-image.svg";
import CustomLink from "../../../../components/CustomLink/CustomLink";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";

interface Props {
  open: boolean;
  handleOpen: Function;
  handleRequestACallBack: any;
  handleContinueInABCDApp: any;
  handleGoBack: any;
}

const LeadIntentPopup: FC<Props> = ({
  open,
  handleOpen,
  handleRequestACallBack,
  handleContinueInABCDApp,
  handleGoBack,
}) => {
  const { width } = useWindowSize();
  const { t } = useAppTranslation("common");

  return (
    <CustomPopup
      open={open}
      handleOpen={handleGoBack}
      btnLabel={t("home.actionButtons.goBack")}
      className={`lead-intent-popup ${width < tabViewPoint ? "" : "for-web"}`}
      btnStartIcon={
        <ChevronLeftIcon fontSize="small" sx={{ color: Colors.red }} />
      }
      transitionType="slide"
    >
      <Stack rowGap="2rem">
        <Stack
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          rowGap=".625rem"
        >
          <img src={greatChoiceImg} alt="great-choice" />
          <Typography variant="h3">{t("home.leadIntent.title")}</Typography>
          <Typography variant="subtitle2">
            {t("home.leadIntent.subtitle")}
          </Typography>
        </Stack>
        <Stack
          flexDirection="column"
          rowGap="1rem"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            fullWidth
            variant="contained"
            onClick={handleRequestACallBack}
          >
            {t("home.leadIntent.actionButtons.requestCallback")}
          </Button>
          <CustomLink
            title={t("home.leadIntent.actionButtons.continueInAbcdApp")}
            titleSize={14}
            onClick={handleContinueInABCDApp}
          />
        </Stack>
      </Stack>
    </CustomPopup>
  );
};

export default LeadIntentPopup;
